import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { ApiMessageDescriptor } from './model/api.message';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';
import { MessageModel } from './model/message.model';

@Injectable()
export class HelpMessageService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'MessageManagement',
      authService,
      config.HMMSConfig
    );

  }

  public async create(internalMessage: MessageModel): Promise<MessageModel> {
    return new MessageModel(await super.post<ApiMessageDescriptor>(internalMessage));
  }

  public async getMessages(view?: View): Promise<List<MessageModel>> {
    const orgs = await super.get<List<ApiMessageDescriptor>>(undefined, view);
    orgs.value = orgs.value.map(o => new MessageModel(o));
    return orgs as List<MessageModel>;
  }

  public delete(id: string): Promise<void> {
    return super.delete(id);
  }

  public async update(id: string, internalMessage: MessageModel): Promise<MessageModel> {
    return new MessageModel(await super.put<ApiMessageDescriptor>(id, internalMessage));
  }

  public async getById(id: string): Promise<MessageModel> {
    return new MessageModel(await super.get<ApiMessageDescriptor>(id));
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/help.message/help.message.service.ts